module.exports = __webpack_public_path__ + "static/media/OurCustomer.0989ae58.jpg";